import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { fontSize } from "@/components/signup/utils/font-size";
import { getLoginUrl } from "@/components/signup/utils/url";
import { Link } from "@/libraries/design/components/link/src/link";
import { useLocation } from "@/utils/location-provider";

import { useAccountCreationContext } from "../../hooks/account-creation-context";

export const Login = ({ loginText }: { loginText?: ReactNode }) => {
    const intl = useIntl();
    const location = useLocation();
    const { product } = useAccountCreationContext();

    if (loginText === undefined) {
        loginText = intl.formatMessage(
            {
                id: "BxpUiSignup.SignupForm.existingProduct",
                defaultMessage:
                    "Already have {product}? <logInLink>Log in</logInLink>"
            },
            {
                product: product?.description,
                logInLink: (text: ReactNode) => logInLink(text, location)
            }
        );
    }

    return <p css={existingProductCss}>{loginText}</p>;
};

const logInLink = (text: ReactNode, location: Location) => (
    <Link
        text={text as unknown as string}
        aria-label={text as unknown as string}
        type="inline"
        href={getLoginUrl(location)}
    />
);

const existingProductCss = css({
    fontSize: fontSize.sm,
    margin: "2rem 0 0 !important",
    textAlign: "center"
});
